<template>
  <div class="system-page">
    <div class="container">
      <div class="blocked-phone">
        <img src="../../../html/assets/img/no-phone.svg">
        <p>К сожалению, симулятор не доступен со смартфонов</p>
        <a href="/" class="btn btn-green">Понятно, ну ладно</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Rules',
  };
</script>
